import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Plus, Download, Loader2 } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { getTokens } from '../../utils/tokens';
import { PageHeader, PrimaryBtn, GhostBtn } from '../ui/AdminPagePrimitives';
import OffersPanel from '../inventory/OffersPanel';
import { isManagerOrAbove } from '../../lib/roles';

const Offers = () => {
  const panelRef = useRef(null);
  const [exporting, setExporting] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const { mode } = useSelector((state) => state.theme);
  const { t, isRTL, language } = useLanguage();
  const tk = getTokens(mode);
  const canManage = isManagerOrAbove(user?.role);

  const handleExport = async () => {
    if (!panelRef.current?.exportExcel) return;
    setExporting(true);
    try {
      await panelRef.current.exportExcel();
    } catch (err) {
      console.error('Offers export failed', err);
    } finally {
      setExporting(false);
    }
  };

  const wrapperStyle = {
    background: tk.bg,
    color: tk.text,
    padding: 20,
    minHeight: '100%',
    fontFamily: language === 'ar' ? '"Cairo",sans-serif' : '"DM Sans",sans-serif',
    overflowY: 'auto',
  };

  return (
    <div style={wrapperStyle} className={`theme-${mode}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <PageHeader
        tk={tk}
        title={t('nav.offers')}
        subtitle={t('offers.pageSubtitle')}
        actions={
          <>
            <GhostBtn tk={tk} icon={exporting ? Loader2 : Download} onClick={handleExport}>
              {exporting ? t('monthlyClosing.downloading') : t('offers.downloadExcel')}
            </GhostBtn>
            {canManage ? (
              <PrimaryBtn tk={tk} onClick={() => panelRef.current?.openCreate()} icon={Plus}>
                {t('offers.addOffer')}
              </PrimaryBtn>
            ) : null}
          </>
        }
      />
      <OffersPanel ref={panelRef} canManage={canManage} />
    </div>
  );
};

export default Offers;
